import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { Context } from "./authcontext";
import "../../css/bootstrap.min.css";
import "../../css/animate.min.css";
import "../../css/style.css";
import "../../css/responsive.css";
import "../../css/light-color.css";
import "../../css/floatlabel.css";
import "../../css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { AdminMenu } from "./adminmenu";
import { ToastContainer } from 'react-toastify';
export const  ProtectedRoute = ({ children, roles, ...rest })=>{
    const {user} = useContext(Context);

    console.log(user);
    if (!user) {
      return <Navigate to='/weba/signin' />;
    }

    if (roles && !roles.includes(user.role)) {
      return <Navigate to="/weba/signin" />;
    }

return(
<>
<div className="antialiased light-vz circle-v ">
<AdminMenu userMail={user.currentuser.email}/>
{children}

           
<ToastContainer position="bottom-right"/>
</div>
</>);
}